import { Icon } from '~/ui-components';
import { useLocalization } from '~/framework';
import { Stack, Button } from '@chakra-ui/react';
import { useJIBTableContext } from '../JIBTableContext';
import { faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';

export function HideButtons() {
   const { _js } = useLocalization();
   const {
      isReasonsColumnVisible,
      setReasonsColumnVisible,
      isKeyPointsColumnVisible,
      setKeyPointsColumnVisible,
   } = useJIBTableContext();

   const canShowReasons = isKeyPointsColumnVisible || isReasonsColumnVisible;

   return (
      <Stack direction="row" spacing={4}>
         <Button
            padding="20px"
            leftIcon={isKeyPointsColumnVisible ? <Icon type={faEyeSlash} /> : <Icon type={faEye} />}
            onClick={() => setKeyPointsColumnVisible(!isKeyPointsColumnVisible)}
            variant="outline"
            isDisabled={isReasonsColumnVisible}
         >
            {isKeyPointsColumnVisible ? _js('Hide key points') : _js('Show key points')}
         </Button>
         {canShowReasons && (
            <Button
               padding="20px"
               leftIcon={
                  isReasonsColumnVisible ? <Icon type={faEyeSlash} /> : <Icon type={faEye} />
               }
               onClick={() => setReasonsColumnVisible(!isReasonsColumnVisible)}
               variant="outline"
            >
               {isReasonsColumnVisible ? _js('Hide reasons') : _js('Show reasons')}
            </Button>
         )}
      </Stack>
   );
}
